import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import TabContainer from './TabContainer';
import Blocks from './Blocks';
import FilterMenu from './FilterMenu';

import { bindActionCreators } from 'redux';
import * as actionsTabs from '../../../actions/alert.tabs.actions';
import * as home from '../../../actions/process.home.actions';
import * as actions from '../../../actions/alert.actions';

import { TrashIcon, FilterIcon, RefreshIcon } from '../../../images/icons/WrapSvg';

function toolbar(handleDeleteAll, handleRefresh, handleFilter, secondary) {
    const aux = [];
    aux.push(
        <RefreshIcon key={'refresh-menu-toolbar'} color={'primary'} onClick={handleRefresh} />,
    );
    aux.push(
        <TrashIcon
            key={'checkall-menu-toolbar'}
            className="hand"
            color={'secondary'}
            onClick={handleDeleteAll}
        />,
    );
    aux.push(
        <FilterIcon
            key={'filter-menu-toolbar'}
            color={secondary ? 'secondary' : 'primary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

const getNodeChilds = (local, node, include) => {
    let arr = [];
    if (include || node.id === local) {
        arr.push(node.id);
    }
    if (node.children) {
        node.children.map(
            (n) => (arr = arr.concat(getNodeChilds(local, n, node.id === local || include))),
        );
    }
    return arr;
};

const pagination = 30;

const getFilterData = (alerts, from, to, local, info) => {
    let filtred = alerts ? alerts : [];
    if (from || to || local) {
        const ids = local ? getNodeChilds(local, info.security.hierarchies, false) : [];
        if (from) {
            var startDate = new Date(from);
            filtred = filtred.filter((f) => new Date(f.fechaAlta.date) >= startDate);
        }
        if (to) {
            var endDate = new Date(to);
            filtred = filtred.filter((f) => new Date(f.fechaAlta.date) <= endDate);
        }
        if (local) {
            filtred = filtred.filter((f) => ids.indexOf(f.idLocal.toString()) >= 0);
        }
    }
    return filtred;
};

class Index extends React.Component {
    state = {
        open: null,
        from: undefined,
        to: undefined,
        local: undefined,
        index: 0,
        data: this.props.alerts,
    };

    constructor(props) {
        super(props);
        const tools = [toolbar(this.handleDeleteAll, this.handleRefresh, this.handleFilter, false)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        const { alertTabs, info, alerts } = props;
        const { from, to, local } = state;
        if (alertTabs !== state.alertTabs || info !== state.info || alerts !== state.alerts) {
            state.alertTabs = alertTabs;
            state.info = info;
            state.alerts = alerts;
            state.data = getFilterData(alerts, from, to, local, info);
            return state;
        }
        return null;
    }

    handleChange = (event, value) => {
        const { from, to, local } = this.state;
        const tools = [
            toolbar(
                this.handleDeleteAll,
                this.handleRefresh,
                this.handleFilter,
                from || to || local,
            ),
        ];
        this.props.setTools(tools);
        this.props.setTabAlert(value);
    };

    handleChangeIndex = (index) => {
        const { from, to, local } = this.state;
        const tools = [
            toolbar(
                this.handleDeleteAll,
                this.handleRefresh,
                this.handleFilter,
                from || to || local,
            ),
        ];
        this.props.setTools(tools);
        this.props.setTabAlert(index);
    };

    handleRefresh = (event) => {
        this.props.loadAlert(this.props.session.user);
    };

    handleDeleteAll = (event) => {
        const { alerts, from, to, local, info } = this.state;
        const filterd = getFilterData(alerts, from, to, local, info);
        filterd.map((a) =>
            this.props.deleteAlert(a.id).then((r) => this.props.loadAlert(sessionStorage.user)),
        );
    };

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (from, to, local) => {
        const tools = [
            toolbar(
                this.handleDeleteAll,
                this.handleRefresh,
                this.handleFilter,
                from || to || local,
            ),
        ];
        this.props.setTools(tools);

        if (from || to || local) {
            const ids = local
                ? getNodeChilds(local, this.state.info.security.hierarchies, false)
                : [];
            let filtred = this.state.alerts ? this.state.alerts : [];
            if (from) {
                var startDate = new Date(from);
                filtred = filtred.filter((f) => new Date(f.fechaAlta.date) >= startDate);
            }
            if (to) {
                var endDate = new Date(to);
                filtred = filtred.filter((f) => new Date(f.fechaAlta.date) <= endDate);
            }
            if (local) {
                filtred = filtred.filter((f) => ids.indexOf(f.idLocal.toString()) >= 0);
            }

            this.setState({
                open: undefined,
                from: from,
                to: to,
                local: local,
                ids: ids,
                data: filtred,
            });
        } else {
            this.setState({ open: undefined });
        }
    };

    handleNext = (event) => {
        this.setState({ index: this.state.index + pagination });
    };

    render() {
        const { alertTabs, info, open, from, to, local, index, data } = this.state;

        return (
            <div className={'bg_ice_blue overflow_y_scroll flex_full_column showbar'}>
                <TabContainer>
                    <Blocks
                        type={alertTabs}
                        pagination={pagination}
                        index={index}
                        next={this.handleNext}
                        alerts={data}
                    />
                </TabContainer>
                {open && (
                    <FilterMenu
                        anchorEl={open}
                        from={from}
                        to={to}
                        local={local}
                        info={info}
                        handleClose={this.handleCloseMenu.bind(this)}
                    />
                )}
            </div>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
    alertTabs: PropTypes.number.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions, actionsTabs, home), dispatch);
}

function mapStateToProps(state) {
    return {
        alertTabs: state.alertTabs,
        info: state.info,
    };
}

Index = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Index);

Index = injectIntl(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/alerts/Content.js